import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { selectors as callSelectors } from '../../../../call';
import { setParticipantView } from '../../../actions';
import { ParticipantsView } from '../../../constants';
import { ParticipantsListHeader, ParticipantsListItem } from './';
import './ParticipantsList.scss';
const DEFAULT_DELAY = 400;
const ParticipantsList = ({ participants, selfParticipant }) => {
    let timeoutId;
    const dispatch = useDispatch();
    const [isVisible, setVisible] = useState(true);
    const pinnedStreamId = useSelector(callSelectors.getPinnedStreamId);
    const closeHandler = useCallback(() => {
        setVisible(false);
        timeoutId = setTimeout(() => {
            dispatch(setParticipantView(ParticipantsView.Grid));
        }, DEFAULT_DELAY);
        return () => clearTimeout(timeoutId);
    }, []);
    const containerClassNames = classnames({
        'ml-participant-list': true,
        'ml-participant-list--hidden': !isVisible,
    });
    return (<div className={containerClassNames}>
      <div className="ml-participant-list__header">
        <ParticipantsListHeader amount={participants.length + 1} closeHandle={closeHandler}/>
      </div>
      <div className="ml-participant-list__content">
        <ParticipantsListItem participant={selfParticipant} pinnedStreamId={pinnedStreamId}/>
        {participants.map((participant) => (<ParticipantsListItem key={participant.id} participant={participant} pinnedStreamId={pinnedStreamId}/>))}
      </div>
    </div>);
};
export default ParticipantsList;
